// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-ZzOgT1","alert":"alert-tYYAHO"};